function LoadingScreen(props) {

    return (
        <div id="loadingScreenFrame">
            <div id="loadingScreenloader"/>
        </div>
    )
}

export default LoadingScreen;